import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing a Concierge icon.
 *
 * @function
 * @param {Object} [props] - The component properties
 * @returns {JSX.Element} React component markup
 *
 * @see SvgIcon
 * @example
 * <ConciergeIcon width={24} />
 */
const ConciergeIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M23 21C23 21.55 22.55 22 22 22H11C10.45 22 10 21.55 10 21C10 20.45 10.45 20
            11 20H22C22.55 20 23 20.45 23 21ZM5 3C5 2.45 4.55 2 4 2H2C1.45 2 1 2.45 1 3V12C1 12.55
            1.45 13 2 13H4C4.55 13 5 12.55 5 12V3ZM21.99 19C21.99 18.92 22 18.83 22 18.75C22 16.18
            20.06 14.04 17.5 13.59V13C17.5 12.45 17.05 12 16.5 12C15.95 12 15.5 12.45 15.5 13V13.59C12.94
            14.04 11 16.18 11 18.75C11 18.83 11.01 18.92 11.01 19H21.99ZM13.37 2.18L7.73 3.79C7.3 3.92 7 4.31
            7 4.75V12C7 12.55 7.45 13 8 13H8.64C8.88 13 9.12 12.96 9.34 12.87L16 10.38C16 10.38 17 10 17 9C17 8
            16 8 16 8H13.34C13.11 8 12.89 8.04 12.67 8.11L11.3 8.6L10.9 7.75L12.67 7.12C12.89 7.04 13.12 7 13.35
            7H20C22 7 22 5 22 5L14.62 2.23C14.22 2.08 13.78 2.06 13.37 2.18Z`}
        />
    </SvgIcon>
)

ConciergeIcon.defaultProps = defaultProps

export { ConciergeIcon }
